import { render, staticRenderFns } from "./VehiclesComponent.vue?vue&type=template&id=6ecd1c64"
import script from "./VehiclesComponent.vue?vue&type=script&lang=js"
export * from "./VehiclesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports